import ContactUs from "@/containers/StaticPages/ContactUs";
import { renderMetaData } from "@/utils";
//Redux
import { wrapper } from "@/redux/Store";
import * as dashboardActions from "@/redux/DashboardReducer";

const ContactUsPage = () => {
  const metaData = {
    siteName: "Shyft",
    siteURL: "https://www.betheshyft.com/contact-us",
    title: "Contact us | Shyft",
    description:
      "Contact details for customers interested in health programs for different health programs at Shyft health",
    thumbnail: "https://d1mxd7n691o8sz.cloudfront.net/static/uploads/shyft.jpg",
    h1Text: "Contact details - Shyft health",
  };

  const metaTags = renderMetaData(metaData);

  return (
    <>
      {metaTags}
      <main>
        <ContactUs />
      </main>
    </>
  );
};

export default ContactUsPage;

export const getStaticProps = wrapper.getStaticProps((store) => async () => {
  await store.dispatch(
    dashboardActions.getRibbonData({ pathname: "contact-us" })
  );
});
